export const additionalQuestions = (state) =>
  state?.entities?.additionalQuestion;
